var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H512V31.0941H0V-0.00585938ZM0 62.1941H512V93.2941H0V62.1941ZM0 124.494H512V155.594H0V124.494ZM0 186.794H512V217.894H0V186.794ZM0 249.294H512V280.394H0V249.294ZM0 310.894H512V341.994H0V310.894Z",
    fill: "#BF0A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H155.6V155.594H0V-0.00585938Z",
    fill: "#002868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8 30.1941L88.5 63.0941H123.1L95.1 83.4941L105.8 116.394L77.8 96.0941L49.8 116.394L60.5 83.4941L32.5 63.0941H67.1L77.8 30.1941Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLr);
export default __webpack_public_path__ + "static/media/LR.83e00c006b5acd06d03db59467ce5f92.svg";
export { ForwardRef as ReactComponent };